/**
 * Dashboard fuel-stock display. Backend sends tank book stock in litres.
 * 1 KL = 1000 L. Never divide by 100000 and label it "k KL" — that inflates
 * any stock >= 100 KL by 10× (100000 L would read as 1.00k KL).
 */

export const LITRES_PER_KL = 1000;

export const formatCompactLitres = (value) => {
  const n = Number(value || 0);
  if (!Number.isFinite(n)) {
    return "0.00 L";
  }
  if (Math.abs(n) >= LITRES_PER_KL) {
    return `${(n / LITRES_PER_KL).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })} KL`;
  }
  return `${n.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} L`;
};
